module.exports = __webpack_public_path__ + "static/media/sample.f01d3cc8.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/sample.pdf
// module id = 286
// module chunks = 0